/**
 * 컬렉션 묶음 훅 — 보유(useCollectionQueries)와 같은 정책(staleTime 30초, 비로그인 미호출).
 */
import { useQuery } from "@tanstack/react-query";
import {
  fetchCollectionGroups,
  fetchRecentCollectionCards,
  type CollectionGroupCard,
  type CollectionGroupItem,
} from "../api/collectionGroup";
import { useAuthStore } from "../store/authStore";

export const COLLECTION_GROUP_KEY = ["collection", "groups"] as const;
export const COLLECTION_RECENT_KEY = ["collection", "groups", "recent"] as const;

export function useCollectionGroupsQuery() {
  const isAuthed = useAuthStore((s) => !!s.accessToken);
  return useQuery<CollectionGroupItem[]>({
    queryKey: COLLECTION_GROUP_KEY,
    queryFn: () => fetchCollectionGroups(),
    enabled: isAuthed,
    staleTime: 30_000,
  });
}

/** 홈 §3 — 컬렉션에 담은 카드를 최근 담은 순으로. 담기 시트가 이 키를 무효화한다. */
export function useRecentCollectionCardsQuery(limit: number) {
  const isAuthed = useAuthStore((s) => !!s.accessToken);
  return useQuery<CollectionGroupCard[]>({
    queryKey: [...COLLECTION_RECENT_KEY, limit],
    queryFn: () => fetchRecentCollectionCards(limit),
    enabled: isAuthed,
    staleTime: 30_000,
  });
}
